import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  createTitle: {
    defaultMessage: 'Add new Pickup Contact',
    id: 'aUSVWi',
    description: 'button label to add a new pickup contact',
  },
  createSubTitle: {
    defaultMessage: 'A contact for coordinating pickup',
    id: 'YQg0Xc',
    description: 'shipFromContactDropdown.createSubTitle',
  },
  createContactDDToggleTitle: {
    defaultMessage: 'Add a pickup contact',
    id: 'aAqI5g',
    description: 'shipFromContactDropdown.createContactDDToggleTitle',
  },
  selectContactDDToggleTitle: {
    defaultMessage: 'Select contact...',
    id: '4CCy0Z',
    description: 'shipFromContactDropdown.selectContactDDToggleTitle',
  },
  manageShipFromContactHeader: {
    defaultMessage: 'Manage Pickup Contact',
    description: 'manage pickup contact modal header',
    id: 'Zb6rfY',
  },
  manageShipFromContactNameColumn: {
    description: 'title for shipfrom contact name column',
    defaultMessage: 'Name',
    id: '5eRORJ',
  },
  manageShipFromContactDoneButton: {
    description: '"Done" button to close manage shiup from contact modal',
    defaultMessage: 'Done',
    id: 'K3LWSu',
  },
});
